import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  // No seu nested_select_helper_controller.js
  openModal(event) {
    event.preventDefault()
    const baseUrl = event.currentTarget.dataset.url
    const selectId = this.selectTarget.id

    // encodeURIComponent transforma "#" em "%23"
    const target = encodeURIComponent(`#${selectId}`)

    const urlWithParam = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}select_target=${target}`

    window.Turbo.visit(urlWithParam, { frame: "turbo_modal" })
  }
}